<mat-radio-group aria-label="field?.controlName" [formGroup]="parentForm" [formControl]="relatedFormControl">
  <div *ngFor="let item of field?.items" class="fd-radio-button__option-container">
    <mat-radio-button (change)="handleChange($event)" [value]="item.value" [checked]="item.selected" [disabled]="disabled">{{item.label}}</mat-radio-button>
  </div>
  <mat-error *ngIf="hasError"><div *ngFor="let errorMessage of errorMessages">{{errorMessage}}</div></mat-error>
</mat-radio-group>